var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#333",
  clipPath: "url(#google_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m6.432 14.086-.696 2.6-2.544.053A9.96 9.96 0 0 1 2 11.999a9.95 9.95 0 0 1 1.118-4.598l2.266.415.992 2.252A6 6 0 0 0 6.056 12c0 .734.132 1.437.376 2.086M21.825 10.132Q22 11.042 22 12q-.002 1.075-.219 2.088a10 10 0 0 1-3.52 5.71h-.001l-2.853-.146-.404-2.52a5.96 5.96 0 0 0 2.564-3.044H12.22v-3.956h9.605"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.26 19.798A9.96 9.96 0 0 1 12 22a10 10 0 0 1-8.808-5.26l3.24-2.654a5.946 5.946 0 0 0 8.57 3.045zM18.383 4.302l-3.24 2.652a5.948 5.948 0 0 0-8.767 3.114L3.12 7.401A10 10 0 0 1 12 2c2.426 0 4.651.864 6.383 2.302"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "google_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2 2h20v20H2z"
})))));
export { SvgGoogle as ReactComponent };